module.exports = "https://trybtryb-legacy.web.app/img/granite.4be6dd77.webp";